import { SelectProps as MuiSelectProps, MenuItem } from "@mui/material";
import React from "react";
import {
	SelectContentInfoSubtitle,
	SelectContentInfoTitle,
	SelectContentInfoWrapper,
	SelectContentPriceDate,
	SelectContentPriceText,
	SelectContentPriceWrapper,
	SelectContentWrapper,
	SelectInput,
	SelectItemInfoSubtiitle,
	SelectItemInfoTitle,
	SelectItemInfoWrapper,
	SelectItemPriceDate,
	SelectItemPriceText,
	SelectItemPriceWrapper,
	SelectItemTitle,
	SelectItemWrapper,
	SelectPlaceholder,
	StyledFormControl,
	StyledSelect,
} from "./style";
import { getPlanDateUnit } from "@/utils/plan";
import { TermType } from "@/views/Price/types";

export type PlanItemsMenuType<O = {}> = {
	type: "item";
	id: number;
	value: string;
	title: string;
	subtitle: string;
	price: string;
	dateUnit: TermType;
	originalValue?: O;
};

export type PlanItemsTitleType = {
	type: "title";
	value: string;
};

export type PlanItemsType<O = {}> = PlanItemsMenuType<O> | PlanItemsTitleType;

interface PlanSelectProps extends MuiSelectProps {
	selectedItem: PlanItemsMenuType | undefined;
	value: number | null;
	placeholder: string;
	items: PlanItemsType[];
	width?: number;
	height?: number;
}

export default function PlanSelect({
	placeholder,
	value,
	selectedItem,
	items,
	width,
	height = 40,
	...args
}: PlanSelectProps) {
	return (
		<StyledFormControl width={width}>
			<StyledSelect
				displayEmpty
				input={<SelectInput />}
				height={height + 2}
				fullWidth
				renderValue={(_) => {
					if (!selectedItem) {
						return <SelectPlaceholder>선택해주세요</SelectPlaceholder>;
					}

					return (
						<SelectContentWrapper height={height}>
							<SelectContentInfoWrapper>
								<SelectContentInfoTitle>
									{selectedItem.title}
								</SelectContentInfoTitle>
								<SelectContentInfoSubtitle>
									{selectedItem.subtitle}
								</SelectContentInfoSubtitle>
							</SelectContentInfoWrapper>

							<SelectContentPriceWrapper>
								{selectedItem.price && (
									<SelectContentPriceText>
										{selectedItem.price}
									</SelectContentPriceText>
								)}
								<SelectContentPriceDate>
									/ {getPlanDateUnit(selectedItem.dateUnit)}
								</SelectContentPriceDate>
							</SelectContentPriceWrapper>
						</SelectContentWrapper>
					);
				}}
				value={value || ""}
				{...args}
			>
				{items.map((item, index) => {
					if (item.type === "title") {
						return (
							<SelectItemTitle key={`item-title-${item.value}`}>
								{item.value}
							</SelectItemTitle>
						);
					}

					return (
						<MenuItem value={item.id} key={`item-${item.id}`}>
							<SelectItemWrapper>
								<SelectItemInfoWrapper>
									<SelectItemInfoTitle>
										{item.title}
									</SelectItemInfoTitle>
									<SelectItemInfoSubtiitle>
										{item.subtitle}
									</SelectItemInfoSubtiitle>
								</SelectItemInfoWrapper>

								<SelectItemPriceWrapper>
									{item.price && (
										<SelectItemPriceText>
											{item.price}
										</SelectItemPriceText>
									)}
									<SelectItemPriceDate>
										/ {getPlanDateUnit(item.dateUnit)}
									</SelectItemPriceDate>
								</SelectItemPriceWrapper>
							</SelectItemWrapper>
						</MenuItem>
					);
				})}
			</StyledSelect>
		</StyledFormControl>
	);
}
